import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface NavLink {
    label: string;
    path: string;
    params?: { [key: string]: string };
    exact?: boolean;
}

/**
 * Component for second header navigation.
 */
@Component({
    selector: 'app-second-header',
    templateUrl: './second-header.component.html',
    styleUrls: ['./second-header.component.scss'],
    standalone: false
})
export class SecondHeaderComponent {
    /**
     * The headline text for the header
     */
    @Input() headline?: string;
    /**
     * Whether the search bar is visible.
     */
    @Input() searchBar?: boolean;
    /**
     * The navigation links to show in the header.
     */
    @Input() navLinks?: NavLink[];
    /**
     * Whether the header has a select input.
     */
    @Input() hasSelect = false;
    /**
     * The text for the select input.
     */
    @Input() selectText = 'Deaktivierte einblenden';
    /**
     * The backlink as a router link.
     */
    @Input() backLink? = '';
    /**
     * Whether a button should be shown in the header.
     */
    @Input() showButton = false;

    /**
     * When the search input changes.
     */
    @Output() search = new EventEmitter<string>();
    /**
     * When the select changes.
     */
    @Output() selectChange = new EventEmitter<boolean>();
    /**
     * When the back button is pressed.
     */
    @Output() back = new EventEmitter<void>();

    activeMobileSearch = false;
    archived = false;
    searchString = '';
}
